export default __webpack_public_path__ + "2178ae3.png";